import {productionConstants} from './productionConstants';

const initialState = {
    manufacturedProducts: null,
    loading: false,
    error: null,
};

export function Production(state = initialState, action) {
    switch (action.type) {
        case productionConstants.GET_MANUFACTURED_PRODUCTS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case productionConstants.GET_MANUFACTURED_PRODUCTS_SUCCESS:
            return {
                ...state,
                manufacturedProducts: action.payload,
                loading: false,
            };
        case productionConstants.GET_MANUFACTURED_PRODUCTS_FAILURE:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case productionConstants.CLEAR_MANUFACTURED_PRODUCTS:
            return {
                ...state,
                manufacturedProducts: null,
            };
        default:
            return state;
    }
}
